import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidemenuComponent } from '@lib-ui';
import { RouterOutlet } from '@angular/router';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SidemenuComponent,
    RouterOutlet,
  ],
})
export class CoreModule {
}
